module.exports = __webpack_public_path__ + "img/banner-2.90621a34.jpg";